module.exports = __webpack_public_path__ + "img/album07_19.98769b61.jpg";